import { render, staticRenderFns } from "./base-loader.vue?vue&type=template&id=96cf9d36&scoped=true"
import script from "./base-loader.vue?vue&type=script&lang=js"
export * from "./base-loader.vue?vue&type=script&lang=js"
import style0 from "./base-loader.vue?vue&type=style&index=0&id=96cf9d36&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96cf9d36",
  null
  
)

export default component.exports